import { BaseRepository } from "@/repositories/base-repository"
import { type IUser } from "@/interfaces/api/user.interface"

export class UserRepository extends BaseRepository<IUser> {
  protected resourcePath = "auth/users"
}
